<template>
  <ul v-if="hasIcons" class="contacts-group">
    <li v-for="(value, key) in data" :key="key">
      <a v-if="value" target="_blank" :href="c_link__(key, value)">
        <i-icon :name="c_icon__(key)" />
      </a>
      <a v-else class="disable-link">
        <i-icon :name="c_icon__(key)" />
      </a>
    </li>
    <li v-if="showEditBtn">
      <a @click.prevent="$emit('editContact', contact)">
        <i-icon name="pen" />
      </a>
    </li>
    <li v-if="showArrowBtn">
      <a
        :class="{ Expanded: contact.Expanded }"
        @click.prevent="$emit('showContact', contact)"
      >
        <i-icon name="arrow" />
      </a>
    </li>
  </ul>
</template>

<script>
import { __c_icon__, __c_link__ } from "@/includes/helper";

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    showEditBtn: {
      type: Boolean,
      default: false,
    },
    showArrowBtn: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["editContact", "showContact"],
  setup(props) {
    const hasIcons = () => Object.keys(props.data).length > 0;

    return {
      hasIcons,

      c_icon__: __c_icon__,
      c_link__: __c_link__,
    };
  },
};
</script>

<style scoped>
.contacts-group {
  margin: 0;
  padding: 0;

  list-style: none;

  display: flex;
  align-items: center;
}

.contacts-group li {
  display: flex;
}

.contacts-group li:not(:last-child):after {
  content: "";

  flex: 0 0 1px;

  width: 1px;

  margin: 0 10px;

  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("../../assets/img/icons/dash.png");
}

.contacts-group li a .svg {
  color: var(--color-success-active);
}

.contacts-group li a.disable-link .svg {
  color: #3c7c0073;
}

.contacts-group li a:deep(.svg) {
  width: 15px;
  height: 20px;
}

a.Expanded{
  transform: rotate(180deg)
}
</style>
